import React from 'react';

const LanguageBadge = ({ language }) => {
  if (!language) return null;

  const languageDisplay = language.toUpperCase();

  return (
    <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-bold bg-gray-900 text-white border border-gray-600">
      {languageDisplay}
    </span>
  );
};

export default LanguageBadge;